// WCAG 2.2.2: moving content that starts on its own needs a way to stop.
// Honouring the OS setting is the first half; a visible pause control on the
// hero is the second, and is scheduled post-launch.
(function () {
  if (!window.matchMedia) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function apply() {
    if (!reduce.matches) return;
    var vids = document.querySelectorAll('video');
    for (var i = 0; i < vids.length; i++) {
      vids[i].removeAttribute('autoplay');
      vids[i].removeAttribute('loop');
      try { vids[i].pause(); } catch (e) {}
    }
  }
  apply();
  document.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('load', apply);
  if (reduce.addEventListener) reduce.addEventListener('change', apply);
})();
